module.exports = __webpack_public_path__ + "static/mysql-a41f2061186139958ff5624173c3594a.png";